import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NombreComunApi {
    id: number;
    composicionId: number;
    nombre: string;
    codigo: string;
    estado: string;
}

export interface NombreComunFiltros {
    id?: number;
    composicionId?: number;
    estado?: string;
    tipoProductoId?: number;
}

@Injectable({
    providedIn: 'root',
})
export class NombreComunService {
    private readonly _apiUrl = environment.apiSiriUrl;

    public constructor(private http: HttpClient) {}

    public getNombresComunes(
        filtros: NombreComunFiltros = {}
    ): Observable<NombreComunApi[]> {
        let params = new HttpParams();
        if (filtros.id !== undefined) {
            params = params.set('id', String(filtros.id));
        }
        if (filtros.composicionId !== undefined) {
            params = params.set('composicionId', String(filtros.composicionId));
        }
        if (filtros.estado !== undefined) {
            params = params.set('estado', filtros.estado);
        }
        if (filtros.tipoProductoId !== undefined) {
            params = params.set(
                'tipoProductoId',
                String(filtros.tipoProductoId)
            );
        }
        return this.http.get<NombreComunApi[]>(`${this._apiUrl}nombre-comun`, {
            params,
        });
    }
}
